import React from 'react';
import 'twin.macro';
import { HeaderItem } from '@teetsh/app/src/containers/Programmations/ProgV2/Print/components/HeaderItem';
import { Block } from './Block';
import { Header, ItemBlock } from './Row';
import { Item } from '@teetsh/app/src/types/programmations';
import styled from '@emotion/styled';
import { buildMergedGroups } from './buildMergedGroups';

interface Props {
  header?: Header;
  blocks: ItemBlock[];
}

export type MergedRow = {
  item: Item;
  leftBlockWidth: number;
  rightBlockWidth: number;
};

export type MergedGroup = {
  mergedRow?: MergedRow;
  unmergedBlocks: ItemBlock[];
};

// pour les éléments fusionnés, on utilise un grid pour rester bien alignés avec les autres lignes et les headers
// car avec du flex, le nombre de gaps est différent (éléments fusionnés) et donc l'alignement ne correspond pas
const MergedRowGrid = styled.div<{ nbColumns: number }>`
  grid-template-columns: ${props =>
    `repeat(${props.nbColumns}, minmax(0, 1fr))`};
`;
const MergedRowElement = styled.div<{
  elementStart: number;
  elementSpan: number;
}>`
  grid-column: ${props => props.elementStart} / span
    ${props => props.elementSpan};
`;

export function Subrow(props: Props) {
  const { header, blocks } = props;
  const groups = buildMergedGroups(blocks);

  return (
    <div>
      {header && (
        <div tw="mb-2">
          <HeaderItem
            value={header.name}
            color={header.color}
            variant="light"
          />
        </div>
      )}
      <div tw="flex flex-1 flex-col gap-y-2">
        {groups.map(({ mergedRow, unmergedBlocks }, groupIdx) => (
          // Cette div est importante sinon ça baiiize le PDF
          // On dirait que chrome print n'aime pas trop les flex de flex
          <div key={groupIdx}>
            <div tw="flex flex-col gap-y-2">
              {mergedRow && (
                <MergedRowGrid
                  tw="grid gap-2 print:break-after-avoid" // quand la ligne est fusionnée, celle-ci est utilisée comme un titre de section, on évite donc de la séparer du contenu qui suit
                  nbColumns={blocks.length}
                >
                  {mergedRow.item && (
                    <MergedRowElement
                      elementStart={mergedRow.leftBlockWidth + 1}
                      elementSpan={
                        blocks.length -
                        mergedRow.leftBlockWidth -
                        mergedRow.rightBlockWidth
                      }
                    >
                      <Block items={[mergedRow.item]} />
                    </MergedRowElement>
                  )}
                </MergedRowGrid>
              )}
              {unmergedBlocks.length > 0 && (
                <div tw="flex flex-1 gap-x-2">
                  {unmergedBlocks.map((block, blockIdx) => (
                    <Block key={blockIdx} items={block.items} />
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
